import { render, staticRenderFns } from "./Wameedmessages.vue?vue&type=template&id=6ab537b8&scoped=true&"
import script from "./Wameedmessages.vue?vue&type=script&lang=js&"
export * from "./Wameedmessages.vue?vue&type=script&lang=js&"
import style0 from "./Wameedmessages.vue?vue&type=style&index=0&id=6ab537b8&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6ab537b8",
  null
  
)

export default component.exports